export default __webpack_public_path__ + "1f286ed0ddf080748fc46d7532332b15.svg";